export default __webpack_public_path__ + "static/logo-chickasaw-77415b4befdc63633017f63c85d7f31b.png";